import { useEffect, useState } from "react";
import Master from "./Master";

function Video() {
  const [videos, setVideos] = useState([]);

  const loadVideos = async () => {
    const res = await fetch("https://drpatangecitydentalclinic.com/api/allvideo.php");
    const data = await res.json();
    setVideos(data);
  };

  useEffect(() => {
    loadVideos();
  }, []);

  return (
    <Master>

		
    {/* Page Header Start */}
	<div className="page-header">
		<div className="container">
			<div className="row">
				<div className="col-lg-12">
					{/* Page Header Box Start */}
					<div className="page-header-box">
						<h1 className="text-anime-style-2" data-cursor="-opaque">Videos</h1>
						<nav className="wow fadeInUp">
							<ol className="breadcrumb">
								<li className="breadcrumb-item"><a href="./">home</a></li>
								<li className="breadcrumb-item active" aria-current="page">video</li>
							</ol>
						</nav>
					</div>
					{/* Page Header Box End */}
				</div>
			</div>
		</div>
	</div>
	{/* Page Header End */}

      <div className="container">
        <div className="row">
          {videos.map((v) => {
            const videoId = v.link.split("/").pop().split("?")[0];
			console.log(videoId);

            return (
              <div className="col-lg-4 col-md-6 col-12" key={v.id}>
                <div className="mt-3 photo-gallery wow fadeInUp">
                  <iframe
                    width="560"
                    height="315"
                    src={`https://www.youtube.com/embed/${videoId}`}
                    title="YouTube video"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Master>
  );
}

export default Video;